export const paymentFulfillmentStatuses = [
  'unfulfilled',
  'fulfilled',
  'partially_fulfilled',
  'shipped',
  'cancelled',
] as const;

export type PaymentFulfillmentStatus =
  (typeof paymentFulfillmentStatuses)[number];
